import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '@service/utils/util.service';

@Pipe({
    name: 'sanitizeAndEncodeHtml'
})
export class SanitizeAndEncodeHtmlPipe implements PipeTransform {

    constructor() { }

    public transform(value: any): any {
        return UtilService.sanitizeAndEncodeHTML(value);
    }
}
